import directives from './module';

directives.directive('blurMe', () => (scope: ng.IScope, element: ng.IAugmentedJQuery) =>
    element.on('click', () => {
        element[0].focus();
        element[0].blur();
    }));



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/blurMeDirective.ts